import React, { ReactNode } from 'react';

import { SafeAreaView, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { primitive } from 'styles/constants/primitives';

export type FooterProps = {
  children?: ReactNode;
  style?: StyleProp<ViewStyle>;
};

export function Footer({ children, style }: FooterProps) {
  const insets = useSafeAreaInsets();

  return (
    <>
      <View style={[styles.footerContainer, style]}>{children}</View>
      <SafeAreaView style={{ flex: 0, backgroundColor: primitive.$white }} />
      <View style={{ height: insets.bottom, backgroundColor: primitive.$white }} />
    </>
  );
}

const styles = StyleSheet.create({
  footerContainer: {
    backgroundColor: primitive.$white,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: primitive.spacing.$3,
    paddingHorizontal: primitive.spacing.$4,
  },
});
